import React from 'react';
import { RtModal } from '../ui/RtModal';

/**
 * ConfirmRegenerateModal Component
 * Modal for confirming test case script regeneration
 *
 * Props:
 * - isOpen: boolean - Controls modal visibility
 * - onClose: function - Called when modal closes
 * - onConfirm: function - Called when user confirms regeneration
 * - testCaseName: string - Name of the test case
 * - isLoading: boolean - Shows loading state during regeneration
 */
const ConfirmRegenerateModal = ({
  isOpen,
  onClose,
  onConfirm,
  testCaseName = 'Test Case',
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <RtModal
      open={isOpen}
      onClose={onClose}
      title="Confirm Regeneration"
      size="sm"
      variant="confirm"
      closeDisabled={isLoading}
      closeOnBackdrop={!isLoading}
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--primary"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Regenerating…' : 'Regenerate Script'}
          </button>
        </>
      }
    >
      <div className="rt-modal-confirm">
        <p className="rt-modal-confirm__message">
          Are you sure you want to regenerate the automation script?
        </p>
      </div>
    </RtModal>
  );
};

export default ConfirmRegenerateModal;
